import React, { useImperativeHandle } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import PropTypes from 'prop-types';

const defaultOptions = {};

const StripeForm = React.forwardRef(
  (
    {
      onReady = Function.prototype,
      onLoaderror = Function.prototype,
      options = defaultOptions,
      ...otherProps
    },
    ref
  ) => {
    const stripe = useStripe();
    const elements = useElements();

    useImperativeHandle(ref, () => ({
      getElements: () => elements,
      getStripe: () => stripe,
    }));

    return (
      <PaymentElement
        options={options}
        onReady={onReady}
        onLoaderror={onLoaderror}
        className="ioioio"
        {...otherProps}
      />
    );
  }
);

StripeForm.displayName = 'StripeForm';

StripeForm.propTypes = {
  onReady: PropTypes.func,
  onLoaderror: PropTypes.func,
  options: PropTypes.shape(),
};

export default StripeForm;
